import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSlackAuthLink } from '@api';

export const slackAuthLinkGetAsyncSlice = createGetAsyncSlice({
	name: 'slackAuthLink',
	receive: true,
	request: true,
	requestHandler: getSlackAuthLink
});
